var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',[_c('Navigator',[_c('core-view'),_vm._t("default")],2)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }